/**
 * Route configuration object containing all application routes.
 * Organized by feature area (auth, app, errors).
 */
export const ROUTES = {
  auth: {
    login: '/login',
    register: '/register',
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password',
    acceptInvitation: '/accept-invitation/:token',
  },
  app: {
    root: '/',
    dashboard: '/dashboard',
    settings: '/settings',
    settingsTab: '/settings/:tabId',
  },
  general: {
    designSystem: '/design-system',
    components: '/components/:componentName',
    connection: '/connection-error',
    notFound: '*',
  },
  crm: {
    root: '/crm',
    customers: '/crm/customers',
    customer: '/crm/customers/:customerId',
    interactions: '/crm/interactions',
    interaction: '/crm/interactions/:interactionId',
    statuses: '/crm/statuses',
  },
  messaging: {
    root: '/messaging',
    contact: '/messaging/:contactId',
  },
} as const;
